import React from 'react'
import Icon, { IconKey } from 'components/ui/icon'
import { Flex, Text, Box, Container, Heading } from 'components/ds'
import Circle from 'components/ui/circle'

type Props = {
  icon: IconKey
  title?: string
  description: React.ReactNode
  children?: React.ReactNode
  small?: boolean
  center?: boolean
}

const FeatureDescription = ({
  icon,
  title,
  description,
  children,
  small,
  center,
}: Props): React.ReactNode => (
  <Container align="center" top="48px" position="relative">
    <Flex justify="center" align="center" direction="column" gap="5">
      <Circle color="gray" subtle>
        <Icon type={icon} color="#65758B" height={40} width={40} />
      </Circle>

      <Flex gap="2" direction="column" maxWidth="330px" align={center ? 'center' : 'start'}>
        {title && (
          <Heading as="h2" weight={small ? 'medium' : 'bold'}>
            {title}
          </Heading>
        )}
        <Text as="p" size="2">
          {description}
        </Text>
      </Flex>
      {children}
    </Flex>
  </Container>
)

export default FeatureDescription
